<div class="container">
  <span class="top-rectangle"> </span>
  <div class="message">
    <label>{{ message }}</label>
  </div>
  <div class="buttons">
    <button
      [ngClass]="isAgenda ? 'btn-cancel btn-cancel-agenda' : 'btn-cancel'"
      (click)="cancel()"
    >
      {{ btnCancelText }}
    </button>
    <button
      [ngClass]="isAgenda ? 'btn-confirm btn-confirm-agenda' : 'btn-confirm'"
      (click)="confirm()"
    >
      {{ btnConfirmText }}
    </button>
  </div>
</div>
